// Translatable text node.
//
// Renders exactly what the pre-React markup rendered: an element carrying a
// data-i18n key whose text is the English source. The global translator finds
// it by that attribute and rewrites its innerHTML in place.
//
// This only stays safe because the children are literal strings that never
// change. React compares against its own previous render, not the live DOM, so
// an unchanged element is left alone and the translated text survives. Passing
// dynamic children through <T> would let a re-render stomp the translation —
// render dynamic strings as plain text instead, and leave them untranslated.
//
// `k` is the key from the original markup and must be copied verbatim: some are
// readable ids (ml_hero_badge), others the first 16 hex of a SHA-256 of the
// English source. Both are looked up as-is in public/i18n/<lang>.json.
export function T({ k, as: Tag = 'span', children, ...rest }) {
  return (
    <Tag data-i18n={k} {...rest}>
      {children}
    </Tag>
  );
}
